<template>
  <div class="w-100" id="list">
    <vue-good-table
      :columns="columns"
      :rows="invoices"
      @on-row-click="openWindow"
      :selectOptions="{enabled: true, selectOnCheckboxOnly: true }"
    ></vue-good-table>
    <invoice-detail ref="detail" :id="id"></invoice-detail>
  </div>

</template>

<script>

import moment from 'moment'
import api from '@/api'
import InvoiceDetail from '@/views/InvoiceDetail'
import { VueGoodTable } from 'vue-good-table'

export default {
  name: 'invoices-list',

  props: ['invoices', 'selectedStatus'],

  components: {
    VueGoodTable,
    InvoiceDetail,
  },

  data() {
    return {
      id: null,
      columns: [
        {
          label: 'Invoice #',
          field: 'id'
        },
        {
          label: 'Status',
          html: true,
          field: row => `<span class="badge badge-info">${row.status.name}</span>`
        },
        {
          label: 'Client',
          field: 'client.nickname',
        },
        {
          label: 'Amount Due',
          type: 'decimal',
          field: 'total',
        },
        
      ]
    }
  },

  watch: {
    '$route.params.id': function(id) {
      this.id = parseInt(id)
      if (id) {
        this.$refs.detail.$refs.modal.open()
      } else {
        this.$refs.detail.$refs.modal.close()
      }
    }
  },

  mounted() {
    if (this.$route.params.id) {
      this.id = parseInt(this.$route.params.id)
      this.$refs.detail.$refs.modal.open()
    }
  },

  methods: {
    openWindow(params) {
      this.$router.push(`/invoices/${params.row.id}`)
    },

    invoiceUrl(id) {
      return `${api.baseUrl}/invoices/${id}/invoice`
    },

    calendar(date) {
      return moment(date).calendar()
    }
  },

  computed: {

  }
}
</script>

<style scoped>

.filter-control {
  border: none;
  border-bottom: 2px dashed #333;
  background: transparent;
  width: 100px;
}

.hidden {
  display: none;
}

.action-bar {
  height: 48px;
  display: flex;
  align-items: center;
  /* background: orange; */
}

table.flex-table {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 96px);
  margin: 0;
}
table.flex-table thead,
table.flex-table tbody {
  display: block;
}
table.flex-table thead {
  margin-right: 0px;
}
table.flex-table tbody {
  flex: 1;
  overflow-y: scroll;
}
table.flex-table tr {
  width: 100%;
  display: flex;
}
table.flex-table tr td,
table.flex-table tr th {
  display: block;
  flex: 1;
}
table.flex-widths.flex-table-aligned thead > tr {
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>